import type { FaireProductEntity } from "../../entity_types/product";

export const p_eyr83pkx: FaireProductEntity = {
  token: "p_eyr83pkx",
  type: "product",
  name: "Seaberry & Rose Clay Bath Bomb",
  brandToken: "b_cb27ceb3",
  brandName: "Old Whaling Company",
  imageUrl:
    "https://cdn.faire.com/fastly/35ce5ff924deca6161ad71ebac7b9f0831d2b67873dcd59a5772c369eaa97b92.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b99a35bbb8a7bba890bab84dbda2d5469c67b9f1306cfd88d134f7f7fc47563f.jpeg",
    "https://cdn.faire.com/fastly/006fb3e9c3e44f866ac757d9e08812c01da2b81a1fc04076916ae1edc5b7699f.jpeg",
    "https://cdn.faire.com/fastly/1f0988d67c8f8637f7ca06340f8cd014d2a7d666761b52579b77ba423a7c9c9a.jpeg",
    "https://cdn.faire.com/fastly/39cfdc8d448489f5e8aff62d33f7116113454a688a7adeb8aa372317dac972f0.jpeg",
    "https://cdn.faire.com/fastly/812ebf9ba771b249726eb7905f97de78352289187e2aa7e1fd924256dcfa6116.jpeg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/d2c3f0c0cd125516c3a75ae4b167dd42e424d0f2341c055b2fba3318690457b0/1534448207.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/e5e00c095e0609c07c65c8b996bd8bd25c0308757545100fe59900633c3fc940/1536338083.jpg",
    "https://cdn.faire.com/fastly/2a6cb50c5670f30e8f5ca0f031b376ccca237cbfa5177ba7f8f6bb93aba172d3.jpeg",
    "https://cdn.faire.com/fastly/71ffaacf998e9e77ec25a8628f2e62d872422d447f9a0ba5ba2125c187ccea0a.jpeg",
    "https://cdn.faire.com/fastly/f8d95e00a92c74dd2f6ce74725678d9d2763ee1e00ddeabb1ca903ceb808ab39.jpeg",
    "https://cdn.faire.com/fastly/041202762fff0777c8b30267f82b482198ae6100216ff195c1d7d3ff36509f51.jpeg",
  ],
  priceDollars: 4,
  description:
    "A blend of ripe wild berries, juicy summer plums, and notes of warm vanilla, this summery scent is a year-round favorite that perfectly blends the natural fruity sweetness with the soothing scent of vanilla and light floral base notes. \n\nTop notes: Raspberry, Orange, Plum\nBase notes: Strawberry, Musk, Vanilla\n\nHandmade in historic Charleston, SC, each our 8oz bath bomb will leave your skin feeling moisturized and lightly scented. Our handcrafted bath bomb's soothing fizz and sea-inspired fragrance are perfect for a relaxing soak, rejuvenating the senses. The rose kaolin clay in this bath bomb absorbs excess oil while gently exfoliating for a deeper cleanse. Our bath bombs are 2.75\" round.\n\nOur bath bombs come individually boxed, and are wrapped in cellophane bags inside the box to prevent oil from seeping into the packaging. \n\nOur bath bombs always make for great gifts! ",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:19.312Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
